import { render } from "./CourseSettingsModal.vue?vue&type=template&id=1a443f3a&scoped=true"
import script from "./CourseSettingsModal.vue?vue&type=script&lang=js"
export * from "./CourseSettingsModal.vue?vue&type=script&lang=js"

import "./CourseSettingsModal.vue?vue&type=style&index=0&id=1a443f3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a443f3a"]])

export default __exports__